import GoogleMap from 'components/GoogleMap/index.js'

export default class PlaceMap extends GoogleMap {
  constructor(element, places) {
    super(element, places)

    this.el.addEventListener('filterChange', this.handleFilterChange.bind(this))
  }

  handleFilterChange(event) {
    const { type, active } = event.detail

    this.markersByType[type].forEach((marker) => {
      active === 'true' ? marker.show() : marker.hide()
    })

    this.resetMapBounds()
  }
}
